import { render, staticRenderFns } from "./nameCard.vue?vue&type=template&id=1e869ef4&scoped=true"
import script from "./nameCard.vue?vue&type=script&lang=js"
export * from "./nameCard.vue?vue&type=script&lang=js"
import style0 from "./nameCard.vue?vue&type=style&index=0&id=1e869ef4&prod&lang=postcss&scoped=true"
import style1 from "./nameCard.vue?vue&type=style&index=1&id=1e869ef4&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e869ef4",
  null
  
)

export default component.exports